import { render, staticRenderFns } from "./food.details.modal.vue?vue&type=template&id=3cf78b13&scoped=true&"
import script from "./food.details.modal.vue?vue&type=script&lang=js&"
export * from "./food.details.modal.vue?vue&type=script&lang=js&"
import style0 from "./food.details.modal.vue?vue&type=style&index=0&id=3cf78b13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf78b13",
  null
  
)

export default component.exports